module.exports = __webpack_public_path__ + "static/media/goods9_1.a2c17b3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/goods9_1.png
// module id = 1240
// module chunks = 0